const mediaItems = [
  {
    title: '年度热门精选合集',
    meta: '影视娱乐 · 已更新至第48期',
    img: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20composition%20with%20coral%20orange%20and%20deep%20teal%20gradient%20layers%2C%20soft%20overlapping%20geometric%20shapes%20suggesting%20cinematic%20content%2C%20minimalist%20editorial%20style%2C%20clean%20background%20with%20subtle%20texture%2C%20modern%20digital%20art%2C%20no%20text%20or%20typography&width=640&height=360&seq=media-card-01&orientation=landscape',
    duration: '48期',
  },
  {
    title: '周末观影指南推荐',
    meta: '影视娱乐 · 每周五更新',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20visual%20with%20flowing%20warm%20amber%20and%20muted%20teal%20gradients%2C%20layered%20translucent%20circles%20floating%20organically%2C%20soft%20glow%20effects%2C%20contemporary%20editorial%20photography%20style%2C%20smooth%20textures%2C%20no%20text%20or%20letters&width=640&height=360&seq=media-card-02&orientation=landscape',
    duration: '32期',
  },
  {
    title: '高分纪录片速览',
    meta: '知识科普 · 持续收录中',
    img: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20abstract%20composition%20with%20warm%20coral%20and%20dark%20charcoal%20tones%2C%20intersecting%20rounded%20rectangles%20with%20soft%20shadows%2C%20clean%20geometric%20design%20aesthetic%2C%20editorial%20layout%20feel%2C%20subtle%20gradient%20transitions%2C%20no%20text&width=640&height=360&seq=media-card-03&orientation=landscape',
    duration: '56部',
  },
  {
    title: '人气动漫追番日历',
    meta: '动漫番剧 · 季度更新',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20design%20with%20vibrant%20warm%20orange%20and%20teal%20color%20blocks%2C%20organic%20curved%20shapes%20intersecting%2C%20soft%20gradient%20background%2C%20contemporary%20digital%20art%20with%20smooth%20transitions%2C%20minimal%20composition%2C%20no%20text%20or%20typography&width=640&height=360&seq=media-card-04&orientation=landscape',
    duration: '24部',
  },
  {
    title: '热门综艺精彩片段',
    meta: '娱乐综艺 · 每日精选',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20visual%20with%20warm%20coral%20gradients%20and%20deep%20teal%20accents%2C%20floating%20geometric%20elements%20with%20soft%20glow%2C%20clean%20modern%20editorial%20aesthetic%2C%20smooth%20layered%20textures%2C%20sophisticated%20minimal%20design%2C%20no%20text&width=640&height=360&seq=media-card-05&orientation=landscape',
    duration: '120+期',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精选视频
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            编辑团队为你精心挑选的优质内容合集
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-xl overflow-hidden cursor-default transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-2 py-1 rounded-md whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 whitespace-nowrap">
                  {item.meta}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}